import React, { useEffect, useRef, useState } from "react";
import { STATS } from "@/data/site";

function Counter({ value, suffix, active }) {
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!active) return;
    let start = 0;
    const duration = 1600;
    const startTime = performance.now();
    const step = (t) => {
      const p = Math.min((t - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.round(eased * value));
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [active, value]);
  return (
    <span>{n.toLocaleString("en-IN")}{suffix}</span>
  );
}

export default function Stats() {
  const ref = useRef(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setActive(true); obs.disconnect(); } },
      { threshold: 0.3 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section
      ref={ref}
      data-testid="stats-section"
      className="relative py-20 md:py-24 px-5 md:px-8 overflow-hidden"
      style={{
        backgroundImage: "linear-gradient(135deg, rgba(11,61,145,0.92), rgba(11,61,145,0.85)), url('https://images.unsplash.com/photo-1488646953014-85cb44e25828?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 text-center">
          {STATS.map((s, i) => (
            <div key={s.label} data-testid={`stat-${i}`} className="text-white">
              <p className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#F9B233] tracking-tight">
                <Counter value={s.value} suffix={s.suffix} active={active} />
              </p>
              <p className="mt-3 text-sm md:text-base text-white/90 tracking-wide uppercase font-medium">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
